class LiveSocketService {
  constructor() {
    this.ws = null;
    this.listeners = [];
  }

  connect() {
    if (this.ws) {
      return;
    }

    const protocol =
      window.location.protocol === 'https:'
        ? 'wss'
        : 'ws';

    this.ws = new WebSocket(
      `${protocol}://${window.location.host}/ws-live`
    );

    this.ws.onopen = () => {
      console.log('LiveSocket connected');
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        this.listeners.forEach((cb) => cb(data));
      } catch (e) {
        console.error(e);
      }
    };

    this.ws.onclose = () => {
      console.log('LiveSocket disconnected');

      this.ws = null;

      setTimeout(() => {
        this.connect();
      }, 3000);
    };
  }

  subscribe(cb) {
    this.listeners.push(cb);

    return () => {
      this.listeners = this.listeners.filter(
        (x) => x !== cb
      );
    };
  }
}

const liveSocket = new LiveSocketService();

export default liveSocket;